import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import OTPLoginPage from '../../components/OTPLoginPage';
import CustomerCheckinForm from '../../components/checkin/CustomerCheckinForm';
import moment from 'moment';
import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
import portalServices from '../../portalServices';
import { useAlert } from '../../../../context/AlertContext';
import { useMqtt } from '../../../../context/MqttContext';
const Step3 = ({queue,service}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={2}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{service.title} For {moment().format("LL")}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}



function CheckinFormPage() {

  
  const location = useLocation();
  const navigate = useNavigate();
  const {AppAlert} = useAlert();
  const {publishMessage} = useMqtt();
  const [savingInprogress,setSavingStatus] = useState(false);


	const {queue,service} = location.state?location.state:{queue:null,service:null};  
  const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);

  const [customerList,setCustomerList] = useState(null);


  const getCustomerList = () => {
    let payload = {
      customerToken:customerToken
    }
    portalServices.getCustomerProfileList(payload).then(res=>{
      setCustomerList(res.data);
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    if(customerToken){
      getCustomerList();
    }
  },[customerToken])

  useEffect(()=>{
    if(queue===null ){
      navigate("/checkin/queue")
    }
  },[])


  const doCheckinWithCustomerId = (customerId) =>{
    let payload = {
        "queueId":queue.id,
        "serviceId":service.id,
        "customerId":customerId
    }
    setSavingStatus(true)
    portalServices.doCheckinWithCustomerId(payload).then(res=>{
        publishMessage({event:"new_token",token:null})
        navigate("/token-details");
    }).catch(error=>{
        AppAlert(error.msg)
    }).finally(()=>{
        setSavingStatus(false)
    })  
  }

  return (
    <>
        <AppHeader/>
        {queue && service &&
        <div className='container'>
          <CheckinBackButton/>
          <Step3 queue={queue} service={service} />
          {
            (customerToken === null || customerToken === undefined) ?
              <OTPLoginPage
                setCustomerToken={setCustomerToken}
              /> 
            :

            <>
            {customerList !== null && customerList.length > 0 &&
              <div>
                <div className='card' >
                  <div className='card-body text-center'>
                    <button className='btn btn-outline-success btn-lg' onClick={()=>setCustomerList([])}>Create New Profile</button>
                  </div>
                </div>
                <div className='text-center my-3'><h3>OR</h3></div>
                {customerList.map(customerDetails=>
                  <div className='card my-2' key={customerDetails.id} >
                    <div className='card-body'>
                      <button className='btn btn-primary' onClick={()=>doCheckinWithCustomerId(customerDetails.id)} >Book Token for {customerDetails.firstName}</button>
                    </div>
                  </div>
                )}
              </div>
                
            }
            
            {customerList !== null && customerList.length === 0 &&
              <CustomerCheckinForm
                queueId={queue.id}
                serviceId={service.id}
                customerToken={customerToken}
              />
            }
            </>
          }
        </div>
        }
    </>
  )
}

export default CheckinFormPage